import deliveryOptionsService from '../../services/deliveryOptionsService'

class DeliveryOptionsController {
  fetchDeliveryOptions = deliveryOptionsService.fetchDeliveryOptions
}

export default new DeliveryOptionsController()



// WEBPACK FOOTER //
// ../src/controllers/deliveryOptionsController/deliveryOptionsController.js